module.exports = __webpack_public_path__ + "images/Fiverr-534558.png";